import { zodResolver } from '@hookform/resolvers/zod'
import type { ReactNode } from 'react'
import { useContext } from 'react'
import { FormProvider as _FormProvider, useForm } from 'react-hook-form'

import { EditContext } from '../../../../_providers/edit'
import { UpdateGuarantorSchema } from '@/_schemas/update-guarantor'

interface FormProviderProps {
  guarantor: any
  children: ReactNode
}

export const FormProvider = ({ guarantor, children }: FormProviderProps) => {
  const { isFormEditable } = useContext(EditContext)

  const methods = useForm<UpdateGuarantorSchema>({
    resolver: zodResolver(UpdateGuarantorSchema),
    defaultValues: {
      name: guarantor.name,
      cpf: guarantor.cpf,
      phone: guarantor.phone,
      email: guarantor.email,
    },
    disabled: !isFormEditable,
  })

  return <_FormProvider {...methods}>{children}</_FormProvider>
}
